// One retry, only for idempotent reads and transport/service interruptions.
// Integrity failures and authorization denials are never retried.
function retryable(error){
 if(/integrity|could not be verified|boundary|unauthorized|forbidden/i.test(error?.message||''))return false;
 return [408,429,502,503,504,521,522].includes(Number(error?.status))||require('./backgroundReadPolicy').transientReadFailure(error);
}
async function transientSavedRead(read,{signal,enabled=false,delay=750}={}){
 try{return await read();}catch(error){
  if(!enabled||signal?.aborted||!retryable(error))throw error;
  await new Promise((resolve,reject)=>{const abort=()=>{clearTimeout(timer);reject(Object.assign(Error('Saved read canceled'),{name:'AbortError'}));};const timer=setTimeout(()=>{signal?.removeEventListener('abort',abort);resolve();},delay);signal?.addEventListener('abort',abort,{once:true});});
  if(signal?.aborted)throw Object.assign(Error('Saved read canceled'),{name:'AbortError'});
  return read();
 }
}
module.exports={transientSavedRead,retryable};
